import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SynSplashScreenComponent } from './@components';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, SynSplashScreenComponent],
})
export class AppComponent {}
